export const USER_ACCESS_DATA= (status) => [
  {
    id: 1,
    Id: "01",
    userName: "John Doe",
    role: "Manager",
    status:"Inactive",
    createdOn: 30 / 4 / 2011,
  },
  {
    id: 2,
    Id: "02",
    userName: "John Doe",
    role: "Admin",
    status:"Active",
    createdOn: 30 / 4 / 2011,
  },
  {
    id: 3,
    Id: "03",
    userName: "John Doe",
    role: "Manager",
    status:"Inactive",
    createdOn: 30 / 4 / 2011,
  },
];
